var map = {
	"./arrow.svg": 1123,
	"./athletics.jpg": 4736,
	"./bg-masthead.jpg": 6984,
	"./btn_google_signin_dark_normal_web.png": 6600,
	"./business-studies.jpg": 3709,
	"./computer-science.jpg": 2821,
	"./darkblue-hiking.jpg": 442,
	"./darkgreen-football.jpg": 1910,
	"./darkred-ferrari.jpg": 4494,
	"./default-subject.jpg": 3351,
	"./geography.jpg": 2193,
	"./history.jpg": 5623,
	"./light-purple.jpg": 6944,
	"./orange-climbing.jpg": 5053,
	"./schooladminsetup.png": 7603,
	"./tenjinHeader.jpg": 9624,
	"./yellow-cheerful.jpg": 2842
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6190;